import React from 'react'
import { Alert, Stack, Typography } from '@mui/material'
import EmailImapForm from '../../components/integrations/EmailImapForm'
import { useSettingsIntegrations } from '../Settings'

const EmailIntegration: React.FC = () => {
  const { stationId, providers, loading, error, refreshProviders, notify } = useSettingsIntegrations()
  const provider = providers['email']

  if (!stationId) {
    return <Alert severity="info">Select a station to manage integrations.</Alert>
  }

  return (
    <Stack spacing={2.5}>
      <Stack spacing={0.5}>
        <Typography variant="h5" component="h2">
          Email (IMAP)
        </Typography>
        <Typography color="text.secondary">
          Connect an IMAP inbox to receive listener emails directly inside the unified inbox.
        </Typography>
      </Stack>

      {error ? <Alert severity="error">{error}</Alert> : null}

      <EmailImapForm
        stationId={stationId}
        provider={provider}
        initializing={loading && !provider}
        onSaved={refreshProviders}
        onNotify={notify}
      />
    </Stack>
  )
}

export default EmailIntegration
